import React, { useState } from 'react'
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Col, Row, Timeline } from 'antd';
import { useNavigate } from 'react-router-dom';

const Ramrungroup = () => {
	const navigate = useNavigate()
	
	const [collapsed, setCollapsed] = useState(true)

	return (
		<div>
			<div className='flex items-center justify-between w-full custom-grey-bg-faint py-[0.75rem] px-[1.25rem] rounded-[20px] cursor-pointer'
				onClick={() => {
					setCollapsed(!collapsed)
				}}
			>
				<div className='flex items-center text-[20px] leading-[26px] font-semibold '>
					<p className='text-appcolorblack mr-[0.5rem]'>Unit 1:</p>
					<p className='text-appcolorgreyfaintfour'>Getting started with python</p>
				</div>

				<div className='flex items-center'>
					<p className='text-appcolorgreyfaintfour mr-[1.5rem]'>6/6</p>
					{
						collapsed ?
							<DownOutlined />
							:
							<UpOutlined />
					}
				</div>
			</div>

			<div className='mt-[1.7rem]'>
				<Row gutter={16}>
					<Col lg={13} md={24} xs={24}>
						<div
							style={{
								maxHeight: '90%',
								overflowY: 'scroll',
								position: 'relative',
								padding: '2rem'
							}}
						>
							<Timeline
								pending={true}
								items={[
									{
										dot: <div className={`bg-appcolorgreen w-[25px] h-[25px] rounded-full`}></div>,
										children: <div className='relative'>
											<div className='relative'>
												<Row>
													<Col lg={12} md={24} xs={24}>
														<div className='h-[9.3rem] cursor-pointer'>
															<img src="/img/vectors/flappy.svg" alt="flappy" className='w-full h-full' />
														</div>
													</Col>

													<Col lg={12} md={24} xs={24}>
														<div className='h-[9.3rem]'>
															<img src="/img/vectors/coderhigh.svg" alt="coderhigh" className='w-full h-full' />
														</div>
													</Col>
												</Row>
											</div>
										</div>
									},
									{
										dot: <div className={`bg-appcolorgreen w-[25px] h-[25px] rounded-full`}></div>,
										children: <div className='relative'>
											<div className='relative'>
												<Row>
													<Col lg={12} md={24} xs={24}>
														<div className='h-[9.3rem]'>
															<img src="/img/vectors/codejigsaw.svg" alt="codejigsaw" className='w-full h-full' />
														</div>
													</Col>
												</Row>
											</div>
										</div>
									}
								]}
							/>
						</div>
					</Col>
					<Col lg={11} md={24} xs={24}>
						<div className=''>
							<div className='mb-[0.9rem]'>
								<img src="/img/vectors/aboutpython.svg" alt="title" className='rounded-[30px] w-full' />
							</div>

							<div className='px-[1.2rem] pb-[1.2rem] custom-grey-bg-faint mt-[-3rem] pt-[3rem]'>

								<div className="flex justify-between mb-8">
									<div className='flex mr-[0.7rem] rounded-[20px] pt-[0.3rem] pb-[0.4rem] px-[0.8rem] items-center bg-appcolorblackfaintfive '>
										<div className='mr-[0.4rem]'>
											<img src="/img/vectors/key.svg" alt="key" className='w-[0.8rem] h-[0.8rem]' />
										</div>
										<span className='text-appcolorpurplefaintone text-base opacity-[0.5] '>
											<span className="font-bold">
												5
											</span>mins
										</span>
									</div>

									<div className='flex items-center'>
										<div className='flex mr-[0.7rem] rounded-[20px] pt-[0.3rem] pb-[0.4rem] px-[0.8rem] items-center bg-appcolorblackfaintfive'>
											<div className='mr-[0.4rem]'>
												<img src="/img/vectors/key.svg" alt="key" className='w-[0.8rem] h-[0.8rem]' />
											</div>
											<span className='text-appcolorpurplefaintone text-base opacity-[0.5] font-bold'>20,000</span>
										</div>

										<div className='flex mr-[0.7rem] rounded-[20px] pt-[0.3rem] pb-[0.4rem] px-[0.8rem] items-center bg-appcoloryellowfaint'>
											<div className='mr-[0.4rem]'>
												<img src="/img/vectors/star.svg" alt="star" className='w-[0.8rem] h-[0.8rem]' />
											</div>
											<span className='text-appcolorpurplefaintone text-base opacity-[0.5] font-bold'>20,000</span>
										</div>
									</div>
								</div>

								<p className='text-appcolorpurplelightone text-base leading-[141%] mb-[1.6rem]'>
									<p className="mb-2">
										Complete the run in 5mins to earn
									</p>

									Imagine what would happen if you’re building something a bit more complex, like a game.
								</p>

								<div className='flex rounded-[21px] px-[2.6rem] py-[1.3rem] items-center justify-between bg-appcolorwhitefainttwo mb-[2.3rem]'>
									<div>
										<p className='text-appcolorblack opacity-[0.5] text-sm mb-2'>
											Last Time
										</p>
										<p className=''>
											<span className='font-semibold text-appcolorpurplefaintone text-[20px] leading-[24px] pr-1'>7</span>
											<span className='text-base text-appcolorpurplelightone'>m</span>
											<span className='font-semibold text-appcolorpurplefaintone text-[20px] leading-[24px] pr-2 pl-1'>09</span>
											<span className='text-base text-appcolorpurplelightone'>s</span>
										</p>
									</div>

									<div>
										<p className='text-appcolorblack opacity-[0.5] text-sm mb-2'>
											Last Score
										</p>
										<p className='text-[20px] leading-[24px]'>
											<span className='font-semibold text-appcolorpurplefaintone'>6</span> <span className='text-appcolorpurplelightone'>/10</span>
										</p>
									</div>
								</div>

								<div className='flex justify-end'>
									<Button
										className='custom-primary-btn'
										onClick={() => {
											navigate('/ramruns/:id')
										}}
									>
										Start
									</Button>
								</div>
							</div>


						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}

export default Ramrungroup